import axiosClient from '../axiosClient';

export const getCourses = (params) =>
  axiosClient.get('/admin/courses', { params });

export const getCourseDetail = (id) =>
  axiosClient.get(`/admin/courses/${id}`);

export const createCourse = (data) =>
  axiosClient.post('/admin/courses', data);

export const updateCourse = (id, data) =>
  axiosClient.put(`/admin/courses/${id}`, data);

export const deleteCourse = (id) =>
  axiosClient.delete(`/admin/courses/${id}`);

export const getInstructors = () =>
  axiosClient.get('/admin/courses/instructors');
